
// import {IPatient} from "./abstract.patient";
import {Visit} from "../../visit/models/visit";
import * as moment from 'moment';
import {Calculated} from "../../metadata/decorators/calculated.decorator";
import {ScanDocument} from "../../order/models/scan.document";
import {IPersonName} from "../../interfaces/person.name";
import {PatientId} from "./patient.id";
import {IPersonAge} from "../../interfaces/person.age";
import {ConferenceXWorklist} from "../../order/models/conference.x.worklist";


/**
 * Created by shahar on 11-Jul-16.
 */
/**
 * actual class for a patient, including functions.
 * this class should somehow by dynamically extended in the future - for now
 * we have some static methods on it and in the future we will enable dynamic extensions for it
 */
export class Patient implements IPersonName, IPersonAge {//implements IPatient{
	static visit_TYPE;
	patientPersonKey:number;
	personKey:number;
	firstName:string;
	lastName:string;
	middleName:string;
	birthDate;
	genderKey;
	deathIndicator;
	deathDate;
	mobilePhoneNumber:string;
	otherPhoneNumber:string;
	primaryEmailAddress:string;
	address:any[];
	patientIdList: PatientId[];
	patientPreviousId: any[];
	//siteProtCPNextOfKin: any[];
	scanDocument: ScanDocument[];
	conferenceXWorklist: ConferenceXWorklist[];
	//siteProtCPLabResultsLast: any[];
	/* tslint:disable */
	FKLookupRows:any;
	/* tslint:enable */
	languageKey:number;

	get isDeceased() { return (this.deathIndicator === 'Y'); }

	visit: Visit[];
	get firstVisit():any {
		return this.visit?.[0];
	}
}

Patient.visit_TYPE = Visit;
